const sounds =[
    {
        name: "Piano",
        image:require('../images/Instruments/piano.png'),
        audio:require('../audio/soundEffect/piano.mp3')
        
        
    }, {
        name: "Guitar",
        image:require('../images/Instruments/guitar.png'),
        audio:require('../audio/soundEffect/guitar.mp3')
        
    },
   
   
    {
        name: "Drum",
        image:require('../images/Instruments/drum.png'),
        audio:require('../audio/soundEffect/drum.mp3')
        
    }
]

export default sounds;